<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about privacy">
    <Head title="個人情報の取り扱いについて" />
    <h2 class="page-title text-afgreen">
      Privacy policy
      <small>個人情報の取り扱いについて</small>
    </h2>
    <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[700px] pb-[60px] sm:pb-[80px] md:pb-[100px] lg:pb-[120px]">
      <h4>はじめに</h4>
      <p>株式会社エイアンドエフ（以下「当社」といいます）は、当社が運営する「A&Fコーポレートサイト aandf.co.jp」（以下「当サイト」といいます）を通じたサービス（以下「当サービス」といいます）のご提供にあたり、当社及び本サイトの利用者（以下「利用者」といいます）の個人情報（お名前、ご住所、電話番号等の個人を識別することができる情報のことをさし、他の情報と組み合わせて照合することにより個人を識別することができる情報も含まれます。以下「個人情報」といいます）を、個人情報の保護に関する法律を遵守の上、適切な取り扱いを実現いたします。</p>

      <h3>1. 個人情報の取得について</h3>
      <p>当社は、偽りその他不正の手段によらず適正に個人情報を取得いたします。</p>

      <h3>2. 個人情報の利用について</h3>
      <p>当社は、個人情報を以下の利用目的の達成に必要な範囲内で利用いたします。 以下に定めのない目的で個人情報を利用する場合、あらかじめ利用者の同意を得た上で行ないます。</p>

      <ul class="number">
        <li>各種お問い合わせ業務</li>
        <li>お問い合わせ内容の確認業務</li>
        <li>マーケティング分析</li>
        <li>各種製品の企画、開発</li>
        <li>不正利用防止における利用履歴に関するお問い合わせ対応</li>
        <li>1～5に関連する業務</li>
      </ul>

      <h3>3. 個人情報の安全管理について</h3>
      <p>当社は、取り扱う個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。</p>
      <h3>4. 個人情報の委託について</h3>
      <p>当社は、個人情報の取り扱いの全部または一部を第三者に委託する場合は、当該第三者について厳正な調査を行い、取り扱いを委託された個人情報の安全管理が図られるよう当該第三者に対する必要かつ適切な監督を行います。</p>
      <h3>5. 個人情報の第三者提供について</h3>
      <p>当社は、個人情報保護法等の法令に定めのある場合を除き、個人情報をあらかじめ利用者の同意を得ることなく、第三者に開示・提供致しません。</p>
      <h3>6. 個人情報の開示・訂正等について</h3>
      <p>当社は、利用者から自己の個人情報についての開示の請求がある場合、合理的な期間及び範囲で速やかに開示をいたします。 その際、利用者であることが確認できない場合には、開示に応じません。 個人情報の内容に誤りがあり、登録者から訂正・追加・削除の請求がある場合、調査の上、合理的な期間及び範囲で速やかにこれらの請求に対応いたします。 その際、利用者であることが確認できない場合には、これらの請求に応じません。 当社の個人情報の取り扱いにつきまして、上記の請求・お問い合わせ等ございましたら、下記までご連絡くださいますようお願い申し上げます。</p>
      <p>
        &lt;問合せ窓口&gt;
        <br />株式会社エイアンドエフ <br />〒160-0022 東京都新宿区新宿6-27-56 新宿スクエア8F <br />受付時間平日：9:30～18:30 <br />土日・祝日はお休みを頂いております。（夏季・冬季休業日あり） <br />Eメール：<a href="mailto:info@aandf.co.jp" class="text-afgreen hover:text-afgreen-light font-bold">info@aandf.co.jp</a> <br />電話番号：03-3209-7575
      </p>
      <h3>7. 本方針の変更</h3>
      <p>本方針の内容は変更されることがあります。<br />変更後の本方針については、当社が別途定める場合を除いて、当サイトに掲載した時から効力を生じるものとします。</p>
    </div>
  </div>
</template>
